package dev.inmo.wishlist.features.ui.sample.ui

import kotlinx.serialization.Serializable
import dev.inmo.wishlist.features.common.client.models.ViewConfig

@Serializable
class SampleViewConfig : ViewConfig {

}